import React from 'react'
import PropTypes from 'prop-types'
import './StatsRow.scss'

/**
 * StatsRow - Horizontal row optimized for stat cards
 *
 * Auto-adjusts columns based on children count.
 * Responsive breakpoints for mobile/tablet/desktop.
 *
 * @param {React.ReactNode} children - Stat card components
 * @param {string} gap - Gap size ('sm' | 'md' | 'lg')
 * @param {boolean} equalWidth - Force equal width columns
 * @param {string} className - Additional CSS classes
 */
const StatsRow = ({
	children,
	gap = 'md',
	equalWidth = true,
	className = ''
}) => {
	const childCount = React.Children.count(children)

	const rowClass = [
		'stats-row',
		`stats-row--gap-${gap}`,
		`stats-row--count-${Math.min(childCount, 6)}`,
		equalWidth ? 'stats-row--equal-width' : '',
		className
	].filter(Boolean).join(' ')

	return (
		<div className={rowClass}>
			{React.Children.map(children, (child, index) => (
				<div key={index} className="stats-row__item">
					{child}
				</div>
			))}
		</div>
	)
}

StatsRow.propTypes = {
	children: PropTypes.node,
	gap: PropTypes.oneOf(['sm', 'md', 'lg']),
	equalWidth: PropTypes.bool,
	className: PropTypes.string
}

export default StatsRow
